// Название объекта аренды для подписей — по образцу roleMixin.
//
// Зачем: RentProg сдаёт не только автомобили. `company.rental_object` — это 12
// значений, и подпись поля обязана показывать «Велосипед» или «Лодка», а не
// «Автомобиль». Механизм для этого был, но жил 25-строчной цепочкой `if` на 12
// веток, СКОПИРОВАННОЙ в 15 файлов слово в слово (сверено по хешу тела: все 15
// идентичны). Добавление тринадцатого типа означало бы 15 одинаковых правок и 15
// шансов забыть одну.
//
// ПОДКЛЮЧАЕМЫЙ, А НЕ ГЛОБАЛЬНЫЙ — в отличие от roleMixin, и это не вкусовщина:
// `Drawer.vue`, `AppHeader.vue` и `CompanyProfile.vue` держат `rental_object` в
// `methods`. Глобальный миксин с одноимённым computed столкнулся бы с ними
// (Vue 2 ругается на пару computed/method с одним именем), и трогать эти три
// файла ради рефактора незачем. Явный импорт держит область действия ровно там,
// где он нужен.
//
// ЛОКАЛЬНОЕ ОПРЕДЕЛЕНИЕ ПЕРЕКРЫВАЕТ МИКСИН (Vue 2 отдаёт приоритет опциям
// компонента), и на этом держится `ClientPage.vue`: это ПУБЛИЧНАЯ страница
// (`requiresAuth: false`, клиент смотрит свою бронь без логина), стор там пуст, а
// компания приезжает в ответе API. Он оставляет свой `rental_object`, читающий
// `this.company`, и получает из миксина только подпись — `object_name_for_label`
// зовёт `this.rental_object` и попадает в локальный. Если снять его локальное
// определение, страница молча скатится на фолбэк "cars".

// Значение `company.rental_object` → ключ локали с названием в ИМЕНИТЕЛЬНОМ падеже.
// Таблицей, а не цепочкой `if`: добавление типа — одна строка, и видно, что покрыты все.
const OBJECT_NAME_KEYS = Object.assign(Object.create(null), {
  cars: "rental_objects.car_object",
  bicycles: "rental_objects.bicycle_object",
  motorcycles: "rental_objects.motorcycle_object",
  boats: "rental_objects.boat_object",
  construction_machinery: "rental_objects.construction_machinery_object",
  equipment: "rental_objects.equipment_object",
  airplanes: "rental_objects.airplane_object",
  trucks: "rental_objects.truck_object",
  trailers: "rental_objects.trailer_object",
  caravans: "rental_objects.caravan_object",
  taxies: "rental_objects.taxi_object",
  other: "rental_objects.other_object",
});

export { OBJECT_NAME_KEYS };

export default {
  computed: {
    // Форма 1-в-1 как у 13 из 15 снятых копий, включая фолбэк "cars" у компании
    // без выбранного типа. Две оставшиеся копии читали `this.company`, но у одной
    // (`admin/users/List.vue`) это computed поверх того же `getCompany` — то есть
    // то же самое; вторая (`ClientPage.vue`) своё определение сохраняет, см. выше.
    rental_object() {
      const wrap = this.$store && this.$store.getters.getCompany;
      const company = wrap && wrap.company;
      return (company && company.rental_object) || "cars";
    },

    // Именительный падеж: годится для подписи поля и заголовка колонки. В фразы с
    // падежами («нельзя удалить машину» / «нельзя удалить лодку») подставлять
    // НЕЛЬЗЯ — там нужна нейтральная формулировка, см. vue#509 и vue#510.
    object_name_for_label() {
      const key = OBJECT_NAME_KEYS[this.rental_object];
      // Неизвестный тип (новое значение на бэкенде) — пусто, как в снятых копиях:
      // цепочка `if` без совпадений возвращала ''. Пустая подпись заметна глазом,
      // а имя ключа в интерфейсе — нет.
      return key ? this.$t(key) : "";
    },

    object_name_for_label_downcase() {
      return this.object_name_for_label.toLowerCase();
    },
  },
};
